import { render, staticRenderFns } from "./QuestionResultDetails.vue?vue&type=template&id=49353d4d&scoped=true"
import script from "./QuestionResultDetails.vue?vue&type=script&lang=js"
export * from "./QuestionResultDetails.vue?vue&type=script&lang=js"
import style0 from "./QuestionResultDetails.vue?vue&type=style&index=0&id=49353d4d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49353d4d",
  null
  
)

export default component.exports